.divider {
    align-self: center;
}
